.divider {
    align-self: center;
}
